import { RefObject, useEffect } from 'react';
import { isFunction } from 'ramda-adjunct';
import { useBoolean } from './useBoolean';

// taken from https://usehooks.com/useOnScreen/

const isIntersectionObserverSupported = isFunction(window.IntersectionObserver);

export const useOnScreen = (ref: RefObject<HTMLElement>, rootMargin = '0px') => {
  // State and setter for storing whether element is visible
  const { value: isIntersecting, set: setIntersecting } = useBoolean();

  useEffect(() => {
    if (!isIntersectionObserverSupported) {
      return;
    }

    if (!ref.current) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        // Update our state when observer callback fires
        setIntersecting(entry.isIntersecting);
      },
      {
        rootMargin,
      },
    );

    observer.observe(ref.current);

    return () => {
      observer.unobserve(ref.current);
    };
  }, []);

  return isIntersecting;
};
